import classNames from 'classnames';
import Hero from '@components/PageComponents/Hero/Hero';
import { SectionContainer } from '@components/Section';

import Header from '@components/Header/DefaultHeader';
import CallToAction from '@components/PageComponents/CallToAction/CallToAction';
import Layout from '@components/Layout/Layout';
import Styles from './Faq.module.scss';

import GroupFaqs from '@components/GroupFaqs';

const faqs = [
  {
    title: 'About us',
    items: [
      {
        question: `What does Hire Digital do?`,
        answer: `Hire Digital connects companies with talent in marketing, digital
          and content creation. We curate our expert network through a
          rigorous screening process, where members are evaluated for
          their technical skills, work experience and their problem
          solving and communication skills.`,
      },
      {
        question: `What type of talent arrangements does Hire Digital offer?`,
        answer: `We provide solutions for companies looking for individual
          talent or to build a multi-talent team on a project-basis or
          for the long-term. You can choose to work with talent on
          full-time, part-time or hourly arrangements.`,
      },
      {
        question: `Can Hire Digital talent work on-site at my preferred location?`,
        answer: `While most clients find it most efficient to work with
          Hire Digital talent in off-site, remote arrangements, we can
          match you to talent who can work on-site at your preferred
          location.`,
      },
      {
        question: `Do Hire Digital talent communicate in my preferred language(s)?`,
        answer: `Hire Digital’s talent are fully proficient in spoken and written
          English and comprises of members who are fluent in other
          languages, including Mandarin Chinese, Bahasa Indonesian, among
          others. If your brief has specific language requirements, inform
          Hire Digital and we will match you accordingly.`,
      },
    ],
  },
  {
    title: 'How It Works',
    items: [
      {
        question: `How do I get matched to Hire Digital’s talent?`,
        answer: `Tell Hire Digital your requirements and talent needs, or let us
          know by registering here. Our talent specialists will curate and find you the most
          relevant match. You can interview and accept your talent and
          start work immediately.`,
        linkifyWord: 'registering here',
        link: 'https://hiredigital.com/get-started',
      },
      {
        question: `How long does the matching process take, from contacting
          Hire Digital to starting work with the talent?`,
        answer: `Companies typically take between 24 to 72 hours from the time
          when they inform Hire Digital of their talent needs, to start
          working with their matched talent.`,
      },
      {
        question: `What happens if I am not satisfied?`,
        answer: `Hire Digital provides satisfaction guarantees for its clients. If
          the talent does not perform up to your standard, Hire Digital will
          provide a talent replacement.`,
      },
    ],
  },
  {
    title: 'Pricing & Payment',
    items: [
      {
        question: `Who owns the IP of the work created by Hire Digital talent?`,
        answer: `As stipulated in our client agreement, Hire Digital clients own
          the IP of the original work created via Hire Digital, and is
          provided worldwide exclusive rights for publishing. Neither
          Hire Digital nor its talent own the IP of the work created.`,
      },
      {
        question: `How much does Hire Digital cost?`,
        answer: `Hire Digital will find you talent that match your preferred
          rates. We cater to individual requests based on your specific
          talent needs.`,
      },
      {
        question: `What are my payment terms and options?`,
        answer: `Payments are made via credit card or PayPal. For Enterprise
          accounts, we can issue invoicing with payment via PO, wire or
          cheque. Contact us here for more information.`,
        linkifyWord: 'Contact us here',
        link: '/contact',
      },
    ],
  },
];

const mergeFaqItems = (data) => {
  const finalItems = [];

  data.map(({ title, items }) => {
    // this is the top level
    items.map(({ question, answer, items }) => {
      finalItems.push({
        question: question.replace('\n', ' ').replace(/\s+/g, ' '),
        answer: answer.replace('\n', ' ').replace(/\s+/g, ' '),
      });
    });
  });
  return finalItems;
};

const FaqPage = () => {
  const heroTitle = 'Frequently Asked Questions';
  const head = {
    title: `${heroTitle} | Hire Digital`,
    meta: [
      {
        name: 'description',
        content: 'Some of our most frequently asked questions from clients.',
      },
    ],
  };

  return (
    <Layout header={Header} pageHead={head} faqData={mergeFaqItems(faqs)}>
      <Hero parent={Hero.Page.NEW_HERO}>
        <div className={classNames(Hero.Styles.heroContainer, Styles.hero)}>
          <h1 className={Hero.Styles.heroTitle}>{heroTitle}</h1>
        </div>
      </Hero>
      <SectionContainer type={SectionContainer.Type.LIGHTBLUE}>
        <div className={Styles.faqCardsList}>
          <GroupFaqs data={faqs} />
        </div>
      </SectionContainer>
      <CallToAction />
    </Layout>
  );
};

FaqPage.propTypes = {};

export default FaqPage;
